"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconLePetitBallon = void 0;
var React = __importStar(require("react"));
var IconLePetitBallon = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { fill: "#1594A1", d: "M22,12 C22,17.525 17.525,22 12,22 C6.475,22 2,17.525 2,12 C2,6.475 6.475,2 12,2 C12.365,2 12.73,2 13.142,2.046 L13.187,2.046 C18.119,2.639 22,6.886 22,12" }),
        React.createElement("path", { fill: "#FFF", d: "M16.6572,6.2925 L9.8082,5.3335 C9.8082,5.3335 5.5612,12.5475 11.4982,13.9635 L11.0412,17.3885 C9.1692,17.1595 7.7082,17.2505 7.6622,17.5705 C7.6162,17.8905 9.2612,18.3925 11.3152,18.6665 C13.3702,18.9405 15.0592,18.8955 15.1052,18.5755 C15.1502,18.2555 13.8262,17.8445 12.0462,17.5705 L12.4572,14.1915 C18.4842,14.6935 16.6572,6.2925 16.6572,6.2925" }),
        React.createElement("path", { fill: "#EC3838", d: "M13.5527,4.6938 C12.6397,7.0688 14.6027,8.9858 12.2287,8.3468 C11.6807,8.1648 9.8537,7.0688 9.5337,7.8448 C9.5337,7.8448 7.4337,12.6848 12.0457,13.4158 C16.6567,14.1458 16.7487,9.1228 15.7437,8.5298 C14.4657,7.7538 14.0547,6.0638 14.4657,3.3698 C14.5117,2.8678 14.4197,2.5028 14.2827,2.2288 C14.0087,2.1828 13.7817,2.1368 13.5067,2.0908 C13.7357,2.2288 14.2827,2.7308 13.5527,4.6938" })))); };
exports.IconLePetitBallon = IconLePetitBallon;
exports.IconLePetitBallon.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconLePetitBallon;
